import styled from '@emotion/styled';

const ContactBox = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 350px;

  padding: 0;
  margin-right: auto;
  margin-left: 350px;
  margin-top: 0;
  margin-bottom: 0;
`;

export { ContactBox };
